import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseReceiptFormComponent } from '../../components/warehouse-receipt-form/warehouse-receipt-form.component';
import { Guid, once } from '@web/utils';
import { WarehouseReceiptFormData } from '../../models/warehouse-receipt-form-data';
import { Observable } from 'rxjs';
import { WarehouseReceiptDataSourceService } from '../../services/warehouse-receipt-data-source.service';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-warehouse-receipt-edit',
  imports: [
    CommonModule,
    WarehouseReceiptFormComponent,
    SpinnerFilledComponent,
    AlertsComponent,
  ],
  templateUrl: './warehouse-receipt-edit.component.html',
  styleUrl: './warehouse-receipt-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class WarehouseReceiptEditComponent {
  /* prettier-ignore */
  private readonly warehouseReceiptDataSource = inject(WarehouseReceiptDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();
  public readonly fileUploadVisibility = input(false);
  public readonly submitSuccessEvent = output();

  protected data$!: Observable<WarehouseReceiptFormData>;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  public handleSubmitSuccessEvent(data: WarehouseReceiptFormData): void {
    this.warehouseReceiptDataSource
      .updateByFormData(this.id(), data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }

  private configureDataSource(): void {
    this.data$ = this.warehouseReceiptDataSource.fetchDetailsFormById(
      this.id(),
    );

    this.changeDetectorRef.detectChanges();
  }
}
